import request from "@/utils/request";

//1,获取列表
export function getSettings(data){
    return request({
        url:'/admin/getSettings',
        data:data,
        method:'get'
    })
}
//name: 大赛名称
// logo: 大赛logo
// register_start: 报名开始时间
// register_end: 报名结束时间
// upload_end: 提交作品截止时间
//2,修改所有配置项
export function updateAllSettings(data){
    return request({
        url:'/admin/updateAllSettings',
        data:data,
        method:'post'
    })
}
//3,修改一个配置项
export function updateSetting(data){
    return request({
        url:'/admin/updateSetting',
        data:data,
        method:'post'
    })
}

